import React, {useState, Component } from 'react';
import Modal from 'react-bootstrap/Modal'
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import './components/css/Common.css'
import { ReactComponent as MacLogo } from './mac-os-logo.svg';
import { ReactComponent as WindowsLogo } from './windows.svg';
import { saveAs } from 'file-saver';
import ModalVideo from 'react-modal-video';
import { firebaseAnalytics, firebaseAuth, firebaseFirestore, firebase } from './environment/config';
import SimpleReactValidator from 'simple-react-validator';
import validator from 'validator';
import uuid from 'react-uuid';
import { Grid, Image, Container, Menu, Input, Header, Popup, Button, Dropdown, Message, Icon, GridColumn, Divider, Modal as SemanticUIModal } from 'semantic-ui-react'
import Testimonials from './Testimonials'
import { ReactComponent as Influencer } from './svgs/influencer.svg';
import { ReactComponent as Surfer } from './svgs/surfer.svg'
import { ReactComponent as Teacher } from './svgs/teacher.svg';
import { ReactComponent as Discord } from './svgs/discord.svg';
import { ReactComponent as Meet } from './svgs/hangouts-meet.svg'
import { ReactComponent as Zoom } from './svgs/must-watch.svg';
import { ReactComponent as Skype } from './svgs/skype.svg';
import { ReactComponent as Slack } from './svgs/slack.svg'
import { ReactComponent as Teams } from './svgs/teams.svg';
import { ReactComponent as Chip } from './svgs/chip.svg';
import { ReactComponent as Clock } from './svgs/clock.svg';
import { ReactComponent as Battery } from './svgs/battery.svg';
import ReactPlayer from 'react-player'
import secure from './lotties/secure.json'
import meeting from './lotties/call.json'
import Lottie from 'react-lottie';
import AOS from "aos";
import "aos/dist/aos.css";
import { faLaptopHouse, faWindowMinimize } from '@fortawesome/free-solid-svg-icons';
import SoundDemoPanelCollection from './SoundDemoPanelCollection';
import smoothscroll from 'smoothscroll-polyfill';
import CompanyEmailValidator from './utils/company_email_validator';
 
smoothscroll.polyfill();

const UTTERLY_DEMO_VIDEO = 'O1rq-N2_tWg'
const UTTERLY_DEMO = 'https://www.youtube.com/watch?v=O1rq-N2_tWg'

const UTTERLY_PACKAGE_URL = "https://www.utterly.app/Utterly.pkg"
const UTTERLY_FILENAME = "Utterly.pkg"
const UTTERLY_UNINSTALL_URL = "https://www.utterly.app/UTTERLY_UNINSTALL_README"
const UTTERLY_UNINSTALL_FILENAME = "UTTERLY_UNINSTALL_README"

const UTTERLY_ELEVATE_PACKAGE_URL = "https://www.utterly.app/Utterly-Elevate.pkg"
const UTTERLY_ELEVATE_FILENAME = "Utterly-Elevate.pkg"

class App extends React.Component {

  constructor(props) {
    super(props)
    this.validator = new SimpleReactValidator();

    this.workEmailValidator = new CompanyEmailValidator();

    this.state = {
      isVideoOpen: false,
      email: null,
      activeItem: "plugin",
      isSignedIn: false, 
      isEmailSent: false,
      downloadSuccess: null,
      downloadError: null,
      sdkContactOpen: false
    } 
  }
 
  componentDidMount() {
    this.unregisterAuthObserver = firebaseAuth.onAuthStateChanged((user) => {
      if (!user) {
          // console.log("> user is NOT signed in - signing in anonymously")
          firebaseAuth.signInAnonymously()
          .then(() => {
              console.log('User signed in anonymously');
          })
          .catch(error => {
              if (error.code === 'auth/operation-not-allowed') {
                  console.log('Enable anonymous in your firebase console.');
              }
  
              // console.error(error);
          });
      } else {
          console.log("> user is signed in - just listening for changes")
          this.setState({isSignedIn: !user.isAnonymous && user.email !== null})
      }
    })
    AOS.init({
      // initialise with other settings
      duration : 2000,
      anchorPlacement: "bottom-bottom"
    });
    const anchor = window.location.hash;

    if (anchor) {
      const domElement = document.querySelector(anchor);
      if (domElement) {
        domElement.scrollIntoView();
      }
    }
  }
  
  handleDemoImageClick = (()=>{
    // console.log("clicked the image")
    firebaseAnalytics.logEvent('demo-click-main-page')
    this.setOpen(true);
  })

  uninstall = () => {
    firebaseAnalytics.logEvent('uninstall');
    saveAs(UTTERLY_UNINSTALL_URL, UTTERLY_UNINSTALL_FILENAME);
  }

  setOpen = (open) => {
    this.setState({isVideoOpen:open})
  }

  handleSDKEmailSubmit = (async (event) => {
    //first upload the provided email address (and validate it)
    event.preventDefault();
    //var email = this.state.email;
    // var isSignedIn = this.state.isSignedIn;

    let isEmailValid = this.workEmailValidator.isCompanyEmail(this.state.sdk_email);
    // var isEmailValid = validator.isEmail(email);

    if (!isEmailValid) {
      console.log("Email invalid!")
      this.setState({sdkEmailError: "Please enter a valid company email address"});
      return;
    }
    // return;

    const docRef = firebaseFirestore.collection('sdk_emails').doc(this.state.sdk_email);

    await docRef.set({
      email: this.state.sdk_email,
      ts:  firebase.firestore.Timestamp.fromDate(new Date())
    });

    // TODO: add a success dialog
    this.setState({sdkEmailSuccess: "Thank you, we will get in touch with you shortly!", sdkEmailError: null, sdk_email: ""});

    return;
  })


  render() {
    const secureShield = {
      loop: true,
      autoplay: true,
      animationData: secure,
      rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
      }
    };

    const meetingCall = {
      loop: faLaptopHouse,
      autoplay: true,
      animationData: meeting,
      rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
      }
    };

    const { activeItem, downloadSuccess, downloadError } = this.state

    const LoginModal = () => {
      const [show, setShow] = React.useState(false);
      const [email, setEmail] = React.useState("");
      const [downloadError, setDownloadError] = React.useState(null);
      const [downloadSuccess, setDownloadSuccess] = React.useState(null);
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      var message = null;
    
      if (!!downloadSuccess) {
        message = <Container style={{marginTop: '20px', textAlign: 'center', justifyContent:'center', alignItems:'center'}}>
          <Header as='h4' id="fonts" style={{fontWeight: "normal", color: "grey", fontFamily: "Avenir"}}>
            <Icon name="checkmark" color='green' />
            {downloadSuccess}
          </Header>
        </Container>
      }
      if (!!downloadError) {
        message = <Container style={{marginTop: '20px', textAlign: 'center', justifyContent:'center', alignItems:'center'}}>
          <Header as='h4' id="fonts" style={{fontWeight: "normal", color: "grey", fontFamily: "Avenir"}}>
            <Icon name="cancel" color='red' />
            {downloadError}
          </Header>
        </Container>
      }

      if (message === null) {
        message = <Container style={{marginTop: '20px', textAlign: 'center', justifyContent:'center', alignItems:'center'}}>
          <Header as='h4' id="fonts" style={{fontWeight: "normal", color: "grey", fontFamily: "Avenir"}}>
            We will send a download link to your email, you will not need to provide any payment information
          </Header>
        </Container>
      }

      const handleEmailChange = ((e) => {
        e.preventDefault();
        setEmail(e.target.value);
      })

      const handleEmailSubmit = (async (event) => {
        //first upload the provided email address (and validate it)
        event.preventDefault();
        //var email = this.state.email;
        // var isSignedIn = this.state.isSignedIn;
    
        var isEmailValid = validator.isEmail(email);
    
        if (!!email === false || isEmailValid === false) {
          setDownloadError("Please enter a valid email address")
          return;
        }
    
        var confirmationUid = uuid(); 
    
        const actionCodeSettings = {
          // URL you want to redirect back to. The domain (www.example.com) for this
          // URL must be whitelisted in the Firebase Console.
          url: "https://www.utterly.app/update?cid="+confirmationUid+"&email="+email,
          // This must be true.
          handleCodeInApp: true,
        };
    
        const docRef = firebaseFirestore.collection('plugin_download').doc(email);
    
        await docRef.set({
          email: email,
          cid: confirmationUid
        });
    
        firebaseAuth.sendSignInLinkToEmail(email, actionCodeSettings)
        .then(async () => {
    
          // alert("Your download link has been sent to your email. If you did not receive the link, please try again.")
          setDownloadError(null)
          setDownloadSuccess("Your download link has been sent to your email")
          firebaseAnalytics.logEvent('first-download')
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // alert("Please enter a valid email address, if the issue persists - contact support@utterly.app")
          setDownloadError("Please enter a valid email address, if the issue persists - contact support@utterly.app")
        });
        
        setEmail('');
    
        return;
      })
      
       (
          <>
          <button type="button" className="circle-download-button" onClick={handleShow}><i className="download icon"></i> Download for Mac</button>
          <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
          >
              <Modal.Header closeButton>
                  <Modal.Title id="fonts">Sign Up to Download</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  {/* <Input type="email" onChange={this.handleEmailChange} action={{content: 'Submit', onClick: this.handleEmailSubmit}} placeholder='Your email' /> */}
                  {!!downloadSuccess ? <Image src="email-sent.png" style={{height:200, marginLeft:"auto", marginRight:"auto"}} /> : <Image src="to-be-send.png" style={{height:200, marginLeft:"auto", marginRight:"auto"}} /> }
                  {message}
                  <form onSubmit={handleEmailSubmit}>
                      <div style={{display: "flex", flexDirection:"column", marginLeft:"auto", marginRight:"auto"}}>
                        <div className="form-in-modal-login">
                          <label style={{fontWeight: "bold", fontSize: "large"}} id="fonts" for="email">Email</label>
                          <input style={{fontSize: "medium"}} id="fonts" className="input-login" type="email" name="email" placeholder="your@email.com" value={email} onChange={handleEmailChange} />
                        </div>
                        <Button id="fonts" style={{backgroundColor: "#007FFF", color: "white", width: "100px", marginTop: "20px", alignSelf: "flex-end", marginRight: "18px"}} type="submit">Submit</Button>
                        <a style={{alignSelf: "flex-end", fontWeight: "bold", margin: "20px", fontFamily: "Gilroy", fontStyle: "italic"}} href="/plans#plans-table" onClick={()=>firebaseAnalytics.logEvent('plans-comparison-clicked-on-free-version-download')}>*How is the free version compared to Utterly Elevate?</a>
                      </div>
                  </form>
              </Modal.Body>
          </Modal>
          </>
      );
    } 

    const productHuntButton = <div id="product-hunt-container" onClick={()=>{firebaseAnalytics.logEvent('product-hunt-button')}}>
      <a href="https://www.producthunt.com/posts/utterly?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-utterly" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=281703&theme=light" alt="Utterly - Noise cancellation for your Zoom meetings | Product Hunt" style={{width: 250, height: 54}} width="250" height="54" /></a>
    </div>

    const {isVideoOpen} = this.state;
    const style = {
      borderRadius: 0,
      padding: '2em',
    }

    let sdkEmailErrorView = null;
    let sdkEmailSuccessView = null;
    if (!!this.state.sdkEmailSuccess) {
      sdkEmailSuccessView = <Container style={{marginTop: '10px'}}>
        <Header as='h4' id="fonts" style={{fontWeight: "normal", color: 'grey'}}>
          <Icon name="checkmark" color='green' />
          {this.state.sdkEmailSuccess}
        </Header>
      </Container>
    } else if (!!this.state.sdkEmailError) {
      sdkEmailErrorView = <Container style={{marginTop: '10px'}}>
        <Header as='h4' id="fonts" style={{fontWeight: "normal", color: 'grey'}}>
          <Icon name="cancel" color='red' />
          {this.state.sdkEmailError}
        </Header>
      </Container>
    }

    return (
      <div style={{background: "white"}}>
        <div style={{paddingBottom: "100px"}}>
        {/* <Container> */}
          <ModalVideo channel='youtube' autoplay isOpen={isVideoOpen} videoId={UTTERLY_DEMO_VIDEO} onClose={() => this.setOpen(false)} />
          
          <Grid columns={2}>
            <Grid.Column id="main-column">
              <Container className="column-flex-wrap-centered">
                <div className="noise-cancelation-header">
                  <h1 id="main-title-landing">
                    Noise removal for meetings and audio
                  </h1>
                </div>
                <div className="plugin-allows-header">
                  <Header as="h3" id="sub-main-title-landing">
                    With AI at the core, Utterly will remove background noises in your calls and audio streams
                  </Header>
                </div>
                <div className="buttons-header-main"> 
                  {/* {this.state.isSignedIn ?  */}
                    <button type="button" className="circle-download-button" onClick={()=>{saveAs(UTTERLY_ELEVATE_PACKAGE_URL, UTTERLY_ELEVATE_FILENAME); firebaseAnalytics.logEvent('download-package-main-page')}}><i className="download icon"></i> Download for Mac</button>
                    <p style={{margin: 17, textAlign: "center"}}>or</p>
                    <button type="button" className="circle-try-sdk-button" onClick={()=>{document.querySelector('.hello').scrollIntoView({ behavior: 'smooth' });}}>Try the SDK <Icon name="arrow right" color='white' /></button>
                    {/* : <LoginModal /> } */}
                  {/* {productHuntButton} */}
                  {/* <button type="button" className="btn circle-download-button"><i class="download icon"></i> Download for Mac</button> */}
                  {/* <Header.Subheader id="fonts" style={{fontWeight: "bold", fontSize:10, marginTop: 3, marginLeft: 10, color: "gainsboro"}}>
                    macOS 10.15 or higher
                  </Header.Subheader> */}
                  {/* <Button positive onClick={()=>{saveAs(UTTERLY_PACKAGE_URL, UTTERLY_FILENAME); firebaseAnalytics.logEvent('/download-update');}}> Download Now </Button> */}
                </div>
                <div className="availability-logos">
                  <div className="logo-and-description">
                    <MacLogo style={{width: "50px", alignSelf: "center"}} className="logo"/>
                    <div id="description-logo">10.15 or higher</div>
                  </div>
                  <div className="logo-and-description">
                    <WindowsLogo style={{width: "45px"}} className="logo windows-logo"/>
                    <div id="description-logo">Coming soon</div>
                  </div>
                </div>
              </Container>
            </Grid.Column>
            {/* <Grid.Column className="screen"> */}
            <Grid.Column id="non-mobile-right-column">
              <div className="screen">
                {/* <p style={{textAlign: 'right', paddingRight: 80}}>Watch demo</p> */}
                <Image src='screen.png' as='a' href='#' data-aos="zoom-up" data-aos-once onClick={this.handleDemoImageClick} />
                {/* <Header as="h3" id="owner-data" style={{textAlign: 'center'}}>
                  <b>Your privacy is our priority</b> - all processing is done locally on your device
                </Header> */}
              </div>
            </Grid.Column>
          </Grid>
          <Container id="mobile-right-column">
              <div>
                <Image src='screen.png' as='a' href='#' data-aos="zoom-up" data-aos-once onClick={this.handleDemoImageClick} />
                {/* <Image src='play_screen_round.png' as='a' href='#' data-aos="zoom-up" onClick={this.handleDemoImageClick} /> */}
                {/* <Header as="h3" id="owner-data" style={{textAlign: 'center'}}>
                  <b>You privacy is our priority</b> - all processing is done locally on your device
                </Header> */}
              </div>
          </Container>
        </div>
        <div>
          <div style={{background: "#f4f4f4"}}>
            <Header as="h1" id="fonts" style={{textAlign: "center", paddingTop: 100, fontWeight: "normal" }}>Use Utterly with <b>any</b> communication app including</Header>
            <div className="horizontal-flex-main">
              {/* <Image className="margin-60px" src='zoom-icon.png'/>
              <Image className="margin-60px" src='teams-icon.png'/>
              <Image className="margin-60px" src='meet-icon.png'/>
              <Image className="margin-60px" src='discord-icon.png'/>
              <Image className="margin-60px" src='slack-icon.png'/>
              <Image className="margin-60px" src='cisco-icon.png'/> */}
              <Zoom className="margin-60px"/>
              <Teams className="margin-60px" />
              <Meet className="margin-60px" />
              <Discord className="margin-60px" />
              <Slack className="margin-60px" />
              <Skype className="margin-60px"/>
            </div>
          </div>
          <div id="demo" className="vertical-section" style={{paddingBottom: 150, paddingTop: 100, background: "linear-gradient(white, #f4f4f4)"}}>
            <Header as="h1" id="fonts" style={{textAlign: "center"}}>Demo</Header>
            {/* <ReactPlayer data-aos="zoom-down" data-aos-once style={{alignSelf: "center", borderRadius: "5%"}} url={UTTERLY_DEMO} width="50vmax" height="28vmax" controls={true}/> */}
            <SoundDemoPanelCollection />
          </div>
          <div className="vertical-section hello" style={{paddingTop: "100px", justifyContent: "center"}}>
            <div className="section-main-description-title">
              <Header id="section-main-description-title-big" as="h1">Noise removal SDK for your audio and apps</Header>
              <Header as="h3" id="sub-main-title-landing">Our noise removal SDK is offering an unmatched real-time noise removal, while being the best in the market for power efficiency and latency.</Header>
            </div>
            <div className="pictures-box" id="trysdk">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                {/* <Image src="conference.png" data-aos-once data-aos="fade-up"/> */}
                <Chip className="pictures" data-aos-once data-aos="fade-up"/>
                <Header style={{marginLeft: "auto", marginRight: "auto", marginBottom: 55}} id="fonts" as="p">Runs on CPU</Header>
              </div>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                {/* <Image src="conference.png" data-aos-once data-aos="fade-up"/> */}
                <Battery className="pictures" data-aos-once data-aos="fade-down"/>
                <Header id="fonts" as="p" style={{marginLeft: "auto", marginRight: "auto", marginBottom: 55}}>Power efficient</Header>
              </div>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                {/* <Image src="conference.png" data-aos-once data-aos="fade-up"/> */}
                <Clock className="pictures" data-aos-once data-aos="fade-up"/>
                <Header style={{marginLeft: "auto", marginRight: "auto", marginBottom: 55}} id="fonts" as="p">Low latency</Header>
              </div>
            </div>
            
            {/* <button className="circle-contact-sdk-button" onClick={()=>{
              firebaseAnalytics.logEvent("plans: contact us elevate-for-sdk main page")

            }}>Request access</button> */}

            <button className="circle-contact-sdk-button" onClick={()=>{
              firebaseAnalytics.logEvent("plans: contact us elevate-for-sdk main page");
              this.setState({sdkContactOpen: true});
            }}>Request access</button>
            {console.log("sdkContactOpen: ", this.state.sdkContactOpen)}
            {/* <a href="mailto:support@utterly.app" style={{cursor: "pointer", color: "white"}} ></a> */}

          <Modal
            show={this.state.sdkContactOpen}
            onHide={()=>{
              this.setState({sdkContactOpen: false})
            }}
            backdrop="static"
            keyboard={false}
          >
              <Modal.Header closeButton>
                  <Modal.Title id="fonts">Request access for the SDK</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  {/* <Input type="email" onChange={this.handleEmailChange} action={{content: 'Submit', onClick: this.handleEmailSubmit}} placeholder='Your email' /> */}
                  {/* {!!downloadSuccess ? <Image src="email-sent.png" style={{height:200, marginLeft:"auto", marginRight:"auto"}} /> : <Image src="to-be-send.png" style={{height:200, marginLeft:"auto", marginRight:"auto"}} /> } */}
                  {/* {message} */}
                  {/* <Icon name="mail outline" size='huge'></Icon> */}
                  <form onSubmit={(e)=>{
                    e.preventDefault();
                    this.handleSDKEmailSubmit(e);
                  }}>
                      <div style={{display: "flex", flexDirection:"column", marginLeft:"auto", marginRight:"auto"}}>
                        <div className="form-in-modal-login">
                          <label style={{fontWeight: "bold", fontSize: "large"}} id="fonts" for="email">Your email address <font color="red">*</font></label>
                          <input style={{fontSize: "medium"}} id="fonts" className="input-login" type="email" name="email" placeholder="Company email (e.g. john@utterly.app)" value={this.state.sdk_email} onChange={(e)=>{
                            console.log(e.target.value);
                            this.setState({sdk_email: e.target.value})
                          }} />
                        </div>
                        {sdkEmailSuccessView}
                        {sdkEmailErrorView}
                        <Button id="fonts" style={{backgroundColor: "#007FFF", color: "white", width: "100px", marginTop: "20px", alignSelf: "flex-end", marginRight: "18px"}} type="submit">Continue</Button>
                      </div>
                  </form>
              </Modal.Body>
          </Modal>
          </div>
          <div className="vertical-section hello" style={{paddingTop: "100px", justifyContent: "center"}}>
            <div className="section-main-description-title">
                <Header id="section-main-description-title-big" as="h1">Noise removal plugin for your meetings</Header>
            </div>
            <div className="horizontal-section" style={{paddingTop: "70px"}}>
              <Image src="conference.png" style={{width: "50%", height: "100%", alignSelf: "center"}} data-aos-once data-aos="fade-right"/>
              <div className="feature-description" data-aos-once data-aos="fade-left">
                <Header id="fonts" as="h2" style={{fontSize: 45}}>No more meeting interruptions</Header>
                <Header id="fonts" as="h3" style={{fontWeight: "normal"}}>Remove background noise from both ends of your call with one click. Your kids can play in the same room - only your voice will be heard in the call.</Header>
                <button type="button" className="circle-download-button" onClick={()=>{saveAs(UTTERLY_ELEVATE_PACKAGE_URL, UTTERLY_ELEVATE_FILENAME); firebaseAnalytics.logEvent('download-package-main-page')}}><i className="download icon"></i> Download for Mac</button>
              </div>
            </div>
          </div>
          <div className="horizontal-section">
            <div className="feature-description" data-aos-once data-aos="fade-left">
              <Header id="fonts" as="h2" style={{fontSize: 45}}>Work from anywhere in the world</Header>
              <Header id="fonts" as="h3" style={{fontWeight: "normal"}}>Did you always dream of becoming a digital nomad? Only you can hear relaxing waves while working on the beach - your co-workers won't know where you are.</Header>
              <button type="button" className="circle-download-button" onClick={()=>{saveAs(UTTERLY_ELEVATE_PACKAGE_URL, UTTERLY_ELEVATE_FILENAME); firebaseAnalytics.logEvent('download-package-main-page')}}><i className="download icon"></i> Download for Mac</button>
            </div>
            <span data-aos="fade-right" data-aos-once style={{width: "50%", alignSelf: "center"}}><Surfer style={{ height: "auto", width: "100%" }}/></span>
          </div>
          <div className="horizontal-section">
          <span data-aos="fade-right" data-aos-once style={{width: "50%", alignSelf: "center"}}><Influencer style={{ height: "auto", width: "100%" }}/></span>
            <div className="feature-description" data-aos-once data-aos="fade-left">
              <Header id="fonts" as="h2" style={{fontSize: 45}}>Record your videos, live streams and vlogs smoothly</Header>
              <Header id="fonts" as="h3" style={{fontWeight: "normal"}}>That means you don't have to worry about your dog chiming in every time you start recording.</Header>
              <button type="button" className="circle-download-button" onClick={()=>{saveAs(UTTERLY_ELEVATE_PACKAGE_URL, UTTERLY_ELEVATE_FILENAME); firebaseAnalytics.logEvent('download-package-main-page')}}><i className="download icon"></i> Download for Mac</button>
            </div>
          </div>
          <div className="horizontal-section" style={{paddingBottom: "100px"}}>
            <div className="feature-description" data-aos-once data-aos="fade-left">
              <Header id="fonts" as="h2" style={{fontSize: 45}}>High quality online lectures</Header>
              <Header id="fonts" as="h3" style={{fontWeight: "normal"}}>We know it's been hard to give lectures and teach online in pandemic. Utterly will make sure students can hear you and not the construction work across the street.</Header>
              <button type="button" className="circle-download-button" onClick={()=>{saveAs(UTTERLY_ELEVATE_PACKAGE_URL, UTTERLY_ELEVATE_FILENAME); firebaseAnalytics.logEvent('download-package-main-page')}}><i className="download icon"></i> Download for Mac</button>
            </div>
            <span data-aos="fade-right" data-aos-once style={{width: "50%", alignSelf: "center"}}><Teacher style={{ height: "auto", width: "100%" }}/></span>
          </div>
          <div className="horizontal-section" data-aos="fade-up" style={{background: "#f4f4f4", paddingBottom: 100, paddingTop: 50}}>
            <div className="privacy-wrapper" style={{alignSelf: "center", cursor: "default !important"}}>
                <Lottie 
                    options={secureShield}
                    mode='cursor'
                    width="60%"
                >   
                </Lottie>
            </div> 
            <div className="feature-description">
              <Header id="fonts" as="h1" style={{marginTop:30, fontSize: 55}}>Your privacy is our priority</Header>
              <Header id="fonts" as="p" style={{}}>We have no access to your audio data - all the audio processing is done locally on your device</Header>
            </div>
          </div>
          <div style={{paddingBottom: 30, display: "flex", flexDirection: "column"}}>
            <Image src='quote.png'style={{width: "50px", alignSelf: "center", paddingTop: "100px"}} />
            <Testimonials style={{alignSelf: "center"}} />
            {/* <Image src='quote-bottom.png'style={{width: "40px", alignSelf: "center"}} /> */}
          </div>
          {/* {productHuntButton} */}
        </div>
      </div>
    );
  }
}

export default App;
